var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.756,
    height: 16.069,
    viewBox: "0 0 18.756 16.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#78849e;stroke-miterlimit:10;stroke-width:0.977px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M554.3,726.024a1.2,1.2,0,0,1-1.2,1.2H540.223a1.2,1.2,0,0,1-1.2-1.2v-10.2a1.2,1.2,0,0,1,1.2-1.2H553.1a1.2,1.2,0,0,1,1.2,1.2Zm-1.594-.985-2.769-5.875-3.441,4.28-2.517-2.769-3.357,4.364Zm-8.98-7.3a.923.923,0,1,1-.923-.923A.923.923,0,0,1,543.726,717.737Zm11.884,6.978a1.2,1.2,0,0,0,1.2-1.2v-10.2a1.2,1.2,0,0,0-1.2-1.2H542.729a1.2,1.2,0,0,0-1.2,1.2",
    transform: "translate(-538.539 -711.639)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsIco);
export default __webpack_public_path__ + "static/media/pics_ico.2663c329d294e5afe2b22764f75bb178.svg";
export { ForwardRef as ReactComponent };